import PropTypes from "prop-types"

import ScheduleDistributionShape from "./shapes/ScheduleDistributionShape"
import { DistributionFrequencyEnumKeys } from "./shapes/DistributionFrequencyEnum"
import { ScheduleStatusEnumKeys } from "./shapes/ScheduleStatusEnum"

const properties = {
  createdAt: PropTypes.string.isRequired,
  createdBy: PropTypes.string,
  distributionFrequency: PropTypes.oneOf(DistributionFrequencyEnumKeys).isRequired,
  distributions: PropTypes.arrayOf(ScheduleDistributionShape).isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  nextDate: PropTypes.string.isRequired,
  projectId: PropTypes.string.isRequired,
  projectName: PropTypes.string.isRequired,
  shouldRoundCents: PropTypes.bool.isRequired,
  startDate: PropTypes.string.isRequired,
  status: PropTypes.oneOf(ScheduleStatusEnumKeys).isRequired,
  totalAmount: PropTypes.number.isRequired,
  updatedAt: PropTypes.string,
  updatedBy: PropTypes.string
}

const ListSchedulesOutputShapeShape = PropTypes.exact(properties)

export default ListSchedulesOutputShapeShape
export { properties }
